module.exports = __webpack_public_path__ + "media/images/bottom_top_trial_online_rec-90cbf5274a5bbcce9ec91d9e9153fe13.png";